<template>
<div>
	<div>
		<div class="detail-wrap">
			<div class="detail-title">
				针对行业痛点的创新解决方案
			</div>
			<div class="detail-desc">
				我们的平台实现了全流程协作沟通，招聘顾问、管理员及用人部门可以实时共享信息、反馈和进度，确保招聘工作高效、无缝衔接。
			</div>
			<div class="detail-type-wrap">
				<div class="detail-type">
					<div :class="type == 1?'active':'label'" @click="changeType(1)">
						分享推荐裂变
						<div class="activeLine" v-if="type == 1" ></div>
					</div>
					<div :class="type == 2?'active':'label'" @click="changeType(2)">
						电子合同扫码签
						<div class="activeLine" v-if="type == 2"></div>
					</div>
					<div :class="type == 3?'active':'label'" @click="changeType(3)">
						简历公海
						<div class="activeLine" v-if="type == 3"></div>
					</div>
					<div :class="type == 4?'active':'label'" @click="changeType(4)">
						零工发布
						<div class="activeLine" v-if="type == 4"></div>
					</div>
					<div :class="type == 5?'active':'label'" @click="changeType(5)">
						门店管理
						<div class="activeLine" v-if="type == 5"></div>
					</div>
					<div :class="type == 6?'active':'label'" @click="changeType(6)">
						智能薪酬
						<div class="activeLine" v-if="type == 6"></div>
					</div>
					<div :class="type == 7?'active':'label'" @click="changeType(7)">
						宿舍管理
						<div class="activeLine" v-if="type == 7"></div>
					</div>
					<div :class="type == 8?'active':'label'" @click="changeType(8)">
						多渠道曝光
						<div class="activeLine" v-if="type == 8"></div>
					</div>
				</div>
				<div style="margin-top: 20px;display: flex;align-items: center;">
					<img src="../../assets/pic_share.png" style="width: 560px;height: 320px;margin-right: 97px;" v-if="type == 1"/>
					<img src="../../assets/pic_hetong.png" style="width: 560px;height: 320px;margin-right: 97px;" v-else-if="type == 2"/>
					<img src="../../assets/pic_jianli.png" style="width: 560px;height: 320px;margin-right: 97px;" v-else-if="type == 3"/>
					<img src="../../assets/pic_lingong.png" style="width: 560px;height: 320px;margin-right: 97px;" v-else-if="type == 4"/>
					<img src="../../assets/pic_mendian.png" style="width: 560px;height: 320px;margin-right: 97px;" v-else-if="type == 5"/>
					<img src="../../assets/pic_zhineng.png" style="width: 560px;height: 320px;margin-right: 97px;" v-else-if="type == 6"/>
					<img src="../../assets/pic_sushe.png" style="width: 560px;height: 320px;margin-right: 97px;" v-else-if="type == 7"/>
					<img src="../../assets/pic_qudao.png" style="width: 560px;height: 320px;margin-right: 97px;" v-else/>
					<div style="padding-top: 15px;text-align: left;width: calc(100% - 657px);">
						<div v-if="type != 8">
							<div>
								<img src="../../assets/icon_tongdian.png" style="width: 14px;height: 14px;margin-right: 14px;"/>
								<span style="color: #FF0000;font-size: 16px;font-weight: 700;">行业痛点</span>
							</div>
							<div style="margin-left: 28px;font-size:14px;margin-top: 5px;">
								<div v-if="type == 1">
									招聘裂变能力不足，渠道单一，获客成本高
								</div>
								<div v-else-if="type == 2">
									合同签署流程繁琐，时间长，合规风险高
								</div>
								<div v-else-if="type == 3">
									简历信息碎片化，招聘效率低，难以筛选合适候选人
								</div>
								<div v-else-if="type == 4">
									人数众多,市场巨大, 灵活用工管理困难，无法及时应对市场需求波动
								</div>
								<div v-else-if="type == 5">
									针对大型人力资源市场, 门店管理分散，信息不对称，缺乏统一的管理工具
								</div>
								<div v-else-if="type == 6">
									针对人力资源复杂多变的薪资计算方式,  结算方式，管理不透明，工资计算繁琐, 专业人员短缺
								</div>
								<div v-else>
									员工住宿管理不规范，宿舍安排混乱，信息难以追踪
								</div>
							</div>
							<div style="margin-top: 27px;">
								<img src="../../assets/icon_jiejue.png" style="width: 14px;height: 14px;margin-right: 14px;"/>
								<span style="color: #19A84D;font-size: 16px;font-weight: 700;">解决方案</span>
							</div>
							<div style="margin-left: 28px;font-size:14px;margin-top: 5px;line-height: 21px;">
								<div v-if="type == 1">
									分享推荐岗位,实现全员招聘,分享裂变，低成本快速获客 <br/>
									1、分享推荐功能：求职者和员工可以通过分享岗位或推荐朋友加入的方式获取奖励，形成自然裂变传播。<br/>
									2、社交传播效果最大化：通过求职者的社交圈，快速扩大岗位曝光，吸引更多潜在求职者。<br/>
									3、可量化裂变数据：平台记录每一次推荐行为及转化效果，企业可实时评估裂变营销的效率与ROI。
								</div>
								<div v-else-if="type == 2">
									扫码签署，简化流程，确保合规<br/>
									1、扫码签署功能：平台提供扫码签署功能，员工可以通过手机端扫描二维码，直接签署劳动合同或其他用工协议。<br/>
									2、简化流程：无需纸质合同,无需提前导入员工信息,直接现场和录用人员扫码签，大大缩短了合同签署时间，避免了传统手动签署过程中的低效与遗漏。<br/>
									3、合规保障：所有电子合同具有法律效力，平台自动记录签署过程和时间，确保合规性，减少法律风险。
								</div>
								<div v-else-if="type == 3">
									简历公海，提升候选人匹配度<br/>
									1.简历公海功能：平台提供简历公海，企业可以访问来自不同渠道的简历池，快速筛选符合条件的求职者。<br/>
									2.智能筛选与推荐：平台结合大数据与人工智能技术，根据企业岗位需求自动推荐合适候选人，配合智能外呼系统, 提升招聘效率。<br/>
									3.数据集中化管理：所有简历信息统一存储，企业无需担心信息分散或丢失，招聘流程更加高效和可追溯。
								</div>
								<div v-else-if="type == 4">
									灵工平台，灵活应对用工需求<br/>
									1.零工平台：为应对突发的用工需求，平台提供灵工平台功能，企业可以快速发布短期或临时岗位，及时满足市场波动的用工需求。<br/>
									2.灵活调度：企业可以根据企业用工需求, 就近安排灵活就业人员，优化灵工资源的使用。<br/>
									3.快速响应：求职者可以通过平台快速申请临时岗位，并在最短时间内完成岗位匹配与入职手续。
								</div>
								<div v-else-if="type == 5">
									门店管理，集中化运营，简化管理<br/>
									1.门店管理功能：平台提供门店管理功能，企业可以集中管理各个门店的招聘、员工档案、提成等信息，避免信息分散带来的管理难题。<br/>
									2.实时数据共享：通过平台，管理者可以实时查看每个门店的运营情况，掌握整个门店招聘人员的招聘进度   招聘效率<br/>
									3.绩效管理:可给每个门店设置月度绩效,实时统计门店业绩以及达成率<br/>
									4.权限管理与协作：不同门店根据权限进行协作，共享岗位信息、招聘进度和员工档案，实现门店间的统一管理和协同作。
								</div>
								<div v-else-if="type == 6">
									智能薪酬管理，自动化计算与精准发放<br/>
									1.智能薪酬管理：平台提供智能薪酬管理功能，自动根据员工考勤、岗位、绩效,薪资计算方式,结算方案等数据自动计算薪资，避免人工计算错误和繁琐流程。<br/>
									2.自动薪资发放：系统支持批量薪资发放，管理员可以一键发放工资，提升财务工作效率，降本增效, 确保工资实时到账。<br/>
									3.薪酬透明化：员工及招聘成员, 可通过小程序查看费用详情，薪资组成一目了然，提升员工的满意度与信任度。<br/>
								</div>
								<div v-else>
									宿舍管理，系统化安排与监控<br/>
									1.宿舍管理功能：平台提供宿舍管理模块，企业可以高效地安排员工住宿，确保每个员工的住宿需求得到及时满足。<br/>
									2.宿舍状态跟踪：管理员可以实时查看宿舍的使用情况和空余房间，防止宿舍资源浪费。<br/>
									3.智能分配与优化：系统根据员工的入职时间、岗位类型等因素，智能分配宿舍，优化宿舍资源的使用
								</div>
							</div>
							<div style="margin-top: 20px;background: linear-gradient( 80deg, #FFF9F5 0%, #FFD8C4 98%);border-radius: 16px;padding: 16px 30px;position: relative;">
								<div style="font-size: 16px;font-weight: 700;">
									优势
								</div>
								<div style="font-size: 14px;margin-top: 5px;">
									<div v-if="type == 1 || type == 2">
										招聘获客成本降低 ，岗位投递数量提升
									</div>
									<div v-else-if="type == 3">
										缩短招聘时间，提升简历筛选效率，精准匹配度更高
									</div>
									<div v-else-if="type == 4">
										专业的灵活的就业解决方案, 为企业降本增效,解决社会痛点和行业痛点
									</div>
									<div v-else-if="type == 5">
										提升门店管理效率，信息共享与协调更高效
									</div>
									<div v-else-if="type == 6">
										提升薪资发放效率，薪资准确率更高，员工满意度提升
									</div>
									<div v-else>
										宿舍管理效率提升，资源利用率更高，员工住宿满意度更强
									</div>
								</div>
								<img src="../../assets/icon_youshi.png" style="position: absolute;right: 30px;top: 19px;width: 44px;height: 44px;"/>
							</div>
						</div>
						<div v-else>
							<div style="margin-top: 27px;">
								<img src="../../assets/icon_jiejue.png" style="width: 14px;height: 14px;margin-right: 14px;"/>
								<span style="color: #19A84D;font-size: 16px;font-weight: 700;">企业微信深度结合</span>
							</div>
							<div style="margin-left: 28px;font-size:14px;margin-top: 5px;line-height: 21px;">
								实现内部人员高效管理，支持数据实时同步与无缝互传，全面提升企业管理效率。
							</div>
							<div style="margin-top: 27px;">
								<img src="../../assets/icon_jiejue.png" style="width: 14px;height: 14px;margin-right: 14px;"/>
								<span style="color: #19A84D;font-size: 16px;font-weight: 700;">岗位多渠道曝光</span>
							</div>
							<div style="margin-left: 28px;font-size:14px;margin-top: 5px;line-height: 21px;width: 543px;">
								通过微信、抖音、支付宝、快手等多平台小程序，实现岗位多渠道曝光，提升企业招聘曝光度，吸引更多优质候选人。
							</div>
							<div style="margin-top: 27px;">
								<img src="../../assets/icon_jiejue.png" style="width: 14px;height: 14px;margin-right: 14px;"/>
								<span style="color: #19A84D;font-size: 16px;font-weight: 700;">独立招聘链接</span>
							</div>
							<div style="margin-left: 28px;font-size:14px;margin-top: 5px;line-height: 21px;">
								为每个企业生成专属招聘链接，便于精准推广与管理，同时支持岗位信息的快速分享与投递
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="detail-small-type">
				<div>
					<div class="label font700 mt40" >
						分享推荐裂变
					</div>
					<img src="../../assets/pic_share.png" class="pic" />
					<div class="mt10">
						<img src="../../assets/icon_tongdian.png" class="tongdian"/>
						<span class="tongdian_title">行业痛点</span>
					</div>
					<div class="tongdian_desc">
						招聘裂变能力不足，渠道单一，获客成本高
					</div>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">解决方案</span>
					</div>
					<div class="jiejue_desc">
						扫码签署，简化流程，确保合规<br/>
						1、扫码签署功能：平台提供扫码签署功能，员工可以通过手机端扫描二维码，直接签署劳动合同或其他用工协议。<br/>
						2、简化流程：无需纸质合同,无需提前导入员工信息,直接现场和录用人员扫码签，大大缩短了合同签署时间，避免了传统手动签署过程中的低效与遗漏。<br/>
						3、合规保障：所有电子合同具有法律效力，平台自动记录签署过程和时间，确保合规性，减少法律风险。
					</div>
					<div class="youshi">
						<div class="youshi_title">
							优势
						</div>
						<div class="youshi_desc">
							招聘获客成本降低 ，岗位投递数量提升
						</div>
						<img src="../../assets/icon_youshi.png" class="youshi_icon"/>
					</div>
				</div>
				<div>
					<div class="label font700 mt40">
						电子合同扫码签
					</div>
					<img src="../../assets/pic_hetong.png" class="pic" />
					<div class="mt10">
						<img src="../../assets/icon_tongdian.png" class="tongdian"/>
						<span class="tongdian_title">行业痛点</span>
					</div>
					<div class="tongdian_desc">
						合同签署流程繁琐，时间长，合规风险高
					</div>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">解决方案</span>
					</div>
					<div class="jiejue_desc">
						扫码签署，简化流程，确保合规<br/>
						1、扫码签署功能：平台提供扫码签署功能，员工可以通过手机端扫描二维码，直接签署劳动合同或其他用工协议。<br/>
						2、简化流程：无需纸质合同,无需提前导入员工信息,直接现场和录用人员扫码签，大大缩短了合同签署时间，避免了传统手动签署过程中的低效与遗漏。<br/>
						3、合规保障：所有电子合同具有法律效力，平台自动记录签署过程和时间，确保合规性，减少法律风险。
					</div>
					<div class="youshi">
						<div class="youshi_title">
							优势
						</div>
						<div class="youshi_desc">
							招聘获客成本降低 ，岗位投递数量提升
						</div>
						<img src="../../assets/icon_youshi.png" class="youshi_icon"/>
					</div>
				</div>
				<div>
					<div class="label font700 mt40" >
						简历公海
					</div>
					<img src="../../assets/pic_jianli.png" class="pic"/>
					<div class="mt10">
						<img src="../../assets/icon_tongdian.png" class="tongdian"/>
						<span class="tongdian_title">行业痛点</span>
					</div>
					<div class="tongdian_desc">
						简历信息碎片化，招聘效率低，难以筛选合适候选人
					</div>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">解决方案</span>
					</div>
					<div class="jiejue_desc">
						简历公海，提升候选人匹配度<br/>
						1.简历公海功能：平台提供简历公海，企业可以访问来自不同渠道的简历池，快速筛选符合条件的求职者。<br/>
						2.智能筛选与推荐：平台结合大数据与人工智能技术，根据企业岗位需求自动推荐合适候选人，配合智能外呼系统, 提升招聘效率。<br/>
						3.数据集中化管理：所有简历信息统一存储，企业无需担心信息分散或丢失，招聘流程更加高效和可追溯。
					</div>
					<div class="youshi">
						<div class="youshi_title">
							优势
						</div>
						<div class="youshi_desc">
							缩短招聘时间，提升简历筛选效率，精准匹配度更高
						</div>
						<img src="../../assets/icon_youshi.png" class="youshi_icon"/>
					</div>
				</div>
				<div>
					<div class="label font700 mt40" >
						零工发布
					</div>
					<img src="../../assets/pic_lingong.png" class="pic"/>
					<div class="mt10">
						<img src="../../assets/icon_tongdian.png" class="tongdian"/>
						<span class="tongdian_title">行业痛点</span>
					</div>
					<div class="tongdian_desc">
						人数众多,市场巨大, 灵活用工管理困难，无法及时应对市场需求波动
					</div>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">解决方案</span>
					</div>
					<div class="jiejue_desc">
						灵工平台，灵活应对用工需求<br/>
						1.零工平台：为应对突发的用工需求，平台提供灵工平台功能，企业可以快速发布短期或临时岗位，及时满足市场波动的用工需求。<br/>
						2.灵活调度：企业可以根据企业用工需求, 就近安排灵活就业人员，优化灵工资源的使用。<br/>
						3.快速响应：求职者可以通过平台快速申请临时岗位，并在最短时间内完成岗位匹配与入职手续。
					</div>
					<div class="youshi">
						<div class="youshi_title">
							优势
						</div>
						<div class="youshi_desc">
							专业的灵活的就业解决方案, 为企业降本增效,解决社会痛点和行业痛点
						</div>
						<img src="../../assets/icon_youshi.png" class="youshi_icon"/>
					</div>
				</div>
				<div>
					<div class="label font700 mt40" >
						门店管理
					</div>
					<img src="../../assets/pic_mendian.png" class="pic"/>
					<div class="mt10">
						<img src="../../assets/icon_tongdian.png" class="tongdian"/>
						<span class="tongdian_title">行业痛点</span>
					</div>
					<div class="tongdian_desc">
						针对大型人力资源市场, 门店管理分散，信息不对称，缺乏统一的管理工具
					</div>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">解决方案</span>
					</div>
					<div class="jiejue_desc">
						门店管理，集中化运营，简化管理<br/>
						1.门店管理功能：平台提供门店管理功能，企业可以集中管理各个门店的招聘、员工档案、提成等信息，避免信息分散带来的管理难题。<br/>
						2.实时数据共享：通过平台，管理者可以实时查看每个门店的运营情况，掌握整个门店招聘人员的招聘进度   招聘效率<br/>
						3.绩效管理:可给每个门店设置月度绩效,实时统计门店业绩以及达成率<br/>
						4.权限管理与协作：不同门店根据权限进行协作，共享岗位信息、招聘进度和员工档案，实现门店间的统一管理和协同作。
					</div>
					<div class="youshi">
						<div class="youshi_title">
							优势
						</div>
						<div class="youshi_desc">
							提升门店管理效率，信息共享与协调更高效
						</div>
						<img src="../../assets/icon_youshi.png" class="youshi_icon"/>
					</div>
				</div>
				<div>
					<div class="label font700 mt40">
						智能薪酬
					</div>
					<img src="../../assets/pic_zhineng.png" class="pic"/>
					<div class="mt10">
						<img src="../../assets/icon_tongdian.png" class="tongdian"/>
						<span class="tongdian_title">行业痛点</span>
					</div>
					<div class="tongdian_desc">
						针对人力资源复杂多变的薪资计算方式,  结算方式，管理不透明，工资计算繁琐, 专业人员短缺
					</div>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">解决方案</span>
					</div>
					<div class="jiejue_desc">
						智能薪酬管理，自动化计算与精准发放<br/>
						1.智能薪酬管理：平台提供智能薪酬管理功能，自动根据员工考勤、岗位、绩效,薪资计算方式,结算方案等数据自动计算薪资，避免人工计算错误和繁琐流程。<br/>
						2.自动薪资发放：系统支持批量薪资发放，管理员可以一键发放工资，提升财务工作效率，降本增效, 确保工资实时到账。<br/>
						3.薪酬透明化：员工及招聘成员, 可通过小程序查看费用详情，薪资组成一目了然，提升员工的满意度与信任度。<br/>
					</div>
					<div class="youshi">
						<div class="youshi_title">
							优势
						</div>
						<div class="youshi_desc">
							提升薪资发放效率，薪资准确率更高，员工满意度提升
						</div>
						<img src="../../assets/icon_youshi.png" class="youshi_icon"/>
					</div>
				</div>
				<div>
					<div class="label font700 mt40" >
						宿舍管理
					</div>
					<img src="../../assets/pic_sushe.png" class="pic"/>
					<div class="mt10">
						<img src="../../assets/icon_tongdian.png" class="tongdian"/>
						<span class="tongdian_title">行业痛点</span>
					</div>
					<div class="tongdian_desc">
						员工住宿管理不规范，宿舍安排混乱，信息难以追踪
					</div>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">解决方案</span>
					</div>
					<div class="jiejue_desc">
						宿舍管理，系统化安排与监控<br/>
						1.宿舍管理功能：平台提供宿舍管理模块，企业可以高效地安排员工住宿，确保每个员工的住宿需求得到及时满足。<br/>
						2.宿舍状态跟踪：管理员可以实时查看宿舍的使用情况和空余房间，防止宿舍资源浪费。<br/>
						3.智能分配与优化：系统根据员工的入职时间、岗位类型等因素，智能分配宿舍，优化宿舍资源的使用
					</div>
					<div class="youshi">
						<div class="youshi_title">
							优势
						</div>
						<div class="youshi_desc">
							宿舍管理效率提升，资源利用率更高，员工住宿满意度更强
						</div>
						<img src="../../assets/icon_youshi.png" class="youshi_icon"/>
					</div>
				</div>
				<div>
					<div class="label font700 mt40" >
						多渠道曝光
					</div>
					<img src="../../assets/pic_qudao.png" class="pic"/>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">企业微信深度结合</span>
					</div>
					<div class="jiejue_desc">
						实现内部人员高效管理，支持数据实时同步与无缝互传，全面提升企业管理效率。
					</div>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">岗位多渠道曝光</span>
					</div>
					<div class="jiejue_desc">
						通过微信、抖音、支付宝、快手等多平台小程序，实现岗位多渠道曝光，提升企业招聘曝光度，吸引更多优质候选人。
					</div>
					<div class="mt40">
						<img src="../../assets/icon_jiejue.png" class="jiejue"/>
						<span class="jiejue_title">独立招聘链接</span>
					</div>
					<div class="jiejue_desc">
						为每个企业生成专属招聘链接，便于精准推广与管理，同时支持岗位信息的快速分享与投递
					</div>
				</div>
			</div>
			<div class="detail-title mt60">
				双端协同，高效管理
			</div>
			<div class="detail-desc">
				后台与小程序实现实时信息同步，无论是企业管理者还是员工，都可以随时随地查看和处理相关事务，确保数据一致性与管理高效性
			</div>
			<div class="detail-item">
				<div :class="itemType == 1?'itemActive':'item'" @click="changeItemType(1)">
					管理后台核心功能
					<div v-if="itemType == 1" class="activeLine"></div>
				</div>
				<div :class="itemType == 2?'itemActive':'item'" style="margin-left: 40px;" @click="changeItemType(2)">
					小程序端核心功能
					<div v-if="itemType == 2" class="activeLine"></div>
				</div>
				<div v-if="itemType == 2" style="margin-top: 20px;text-align: center;">
				<div style="display: flex;background: #F3F6FB;width: 240px;border-radius: 80px;height: 40px;line-height: 40px;margin-left: calc(50% - 120px);">
					<div :class="item == 1?'itemTypeActive':'itemType'"  @click="changeItem(1)">
						求职者端
					</div>
					<div :class="item == 2?'itemTypeActive':'itemType'" @click="changeItem(2)">
						管理员端
					</div>
				</div>
				<div style="margin-top: 20px;text-align: center;" v-if="item == 1">
					<div style="display: flex;">
						<div class="item1">
							<div>
								<img src="../../assets/icon_link01.png" class="item1Img"/>
							</div>
							<div class="item1Title">投递简历</div>
							<div class="item1Desc">
								快速匹配岗位，实时查看投递状态
							</div>
						</div>
						<div class="item1 ml20">
							<div>
								<img src="../../assets/icon_link02.png" class="item1Img"/>
							</div>
							<div class="item1Title">分享岗位</div>
							<div class="item1Desc">
								成员可自由分享岗位，享受岗位邀约奖励
							</div>
						</div>
						<div class="item1 ml20">
							<div>
								<img src="../../assets/icon_link03.png" class="item1Img"/>
							</div>
							<div class="item1Title">面试通知</div>
							<div class="item1Desc">
								接收面试邀约，并提供地点/时间导航服务。
							</div>
						</div>
						<div class="item1 ml20">
							<div>
								<img src="../../assets/icon_link04.png" class="item1Img"/>
							</div>
							<div class="item1Title">宿舍申请</div>
							<div class="item1Desc">
								根据企业安排快速申请宿舍，查看入住信息
							</div>
						</div>
						<div class="item1 ml20">
							<div>
								<img src="../../assets/icon_link05.png" class="item1Img"/>
							</div>
							<div class="item1Title">借款申请</div>
							<div class="item1Desc">
								线上提交借款申请，实时查询审批状态。
							</div>
						</div>
					</div>
				</div>
				<div style="margin-top: 20px;text-align: center;" v-else>
					<div style="display: flex;">
						<div class="item1">
							<div>
								<img src="../../assets/icon_guanli_01.png" class="item1Img"/>
							</div>
							<div class="item1Title">简历处理</div>
							<div class="item1Desc">
								通过手机即可筛选简历，安排面试，发送录用通知
							</div>
						</div>
						<div class="item1 ml20">
							<div>
								<img src="../../assets/icon_guanli_02.png" class="item1Img"/>
							</div>
							<div class="item1Title">岗位发布</div>
							<div class="item1Desc">
								随时新增或更新岗位信息，满足临时需求
							</div>
						</div>
						<div class="item1 ml20">
							<div>
								<img src="../../assets/icon_guanli_03.png" class="item1Img"/>
							</div>
							<div class="item1Title">借款审批</div>
							<div class="item1Desc">
								简化财务审批流程，提高审批效率
							</div>
						</div>
						<div class="item1 ml20">
							<div>
								<img src="../../assets/icon_guanli_04.png" class="item1Img"/>
							</div>
							<div class="item1Title">合同签署</div>
							<div class="item1Desc">
								支持电子签署合同功能，移动办公更高效
							</div>
						</div>
					</div>
					<div style="display: flex;margin-top: 20px;text-align: center;">
						<div class="item1" style="background: #ffffff;">
						</div>
						<div class="item1 ml20">
							<div>
								<img src="../../assets/icon_guanli_05.png" class="item1Img"/>
							</div>
							<div class="item1Title">人员录入</div>
							<div class="item1Desc">
								支持线下拍照录入求职者信息，便于招聘会或现场招募。自动生成候选人档案，录入效率高，数据无缝接入后台管理系统。
							</div>
						</div>
						<div class="item1 ml20">
							<div>
								<img src="../../assets/icon_guanli_06.png" class="item1Img"/>
							</div>
							<div class="item1Title">员工档案</div>
							<div class="item1Desc">
								查看员工的当前用工记录（如所在岗位、薪资状态）。查询员工的历史用工记录（如曾服务的岗位、入离职时间等）
							</div>
						</div>
						<div class="item1 ml20" style="background: #ffffff;">
						</div>
					</div>
				</div>
			</div>
			<div style="margin-top: 20px;text-align: center;" v-else>
				<div style="display: flex;">
					<div class="item1">
						<div>
							<img src="../../assets/icon_guanli01.png" class="item1Img"/>
						</div>
						<div class="item1Title">企业管理</div>
						<div class="item1Desc">
							多企业账号支持，适用于集团化企业或中介机构管理。数据分级与权限管理，确保信息安全与团队协作效率
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli02.png" class="item1Img"/>
						</div>
						<div class="item1Title">岗位管理</div>
						<div class="item1Desc">
							岗位信息发布与编辑，支持批量操作。智能化岗位推荐与自动投放功能，提高招聘效率
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli03.png" class="item1Img"/>
						</div>
						<div class="item1Title">简历管理</div>
						<div class="item1Desc">
							实时接收简历投递，支持筛选、分类、标签化管理。一键邀约面试与多渠道通知，节约沟通成本
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli04.png" class="item1Img"/>
						</div>
						<div class="item1Title">面试管理</div>
						<div class="item1Desc">
							在线安排面试，自动发送通知提醒。支持面试结果记录与后续流程跟进（如录用或不录用）
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli05.png" class="item1Img"/>
						</div>
						<div class="item1Title">用工档案管理</div>
						<div class="item1Desc">
							查看员工的当前用工记录（如所在岗位、薪资状态）。查询员工的历史用工记录（如曾服务的岗位、入离职时间等）
						</div>
					</div>
				</div>
				<div style="display: flex;margin-top: 20px;text-align: center;padding-left: calc(10% - 30px);padding-right: calc(10% - 30px);;">
					<div class="item1" >
						<div>
							<img src="../../assets/icon_guanli06.png" class="item1Img"/>
						</div>
						<div class="item1Title">合同管理</div>
						<div class="item1Desc">
							多企业账号支持，适用于集团化企业或中介机构管理。数据分级与权限管理，确保信息安全与团队协作效率
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli07.png" class="item1Img"/>
						</div>
						<div class="item1Title">借款管理</div>
						<div class="item1Desc">
							员工可以申请借款，管理员可审核并发放。借款数据自动统计，还款状态实时更新，降低财务风险
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli08.png" class="item1Img"/>
						</div>
						<div class="item1Title">宿舍管理</div>
						<div class="item1Desc">
							宿舍分配与入住记录管理，支持申请与审核流程。自动生成宿舍使用报告，便于后续优化
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli09.png" class="item1Img"/>
						</div>
						<div class="item1Title">薪资计算与发放</div>
						<div class="item1Desc">
							自动化工资核算：支持按小时、按天、按月等多种计算方式。批量工资发放，支持银行对接或第三方支付
						</div>
					</div>
				</div>
			</div>
			</div>
			<div class="detail-small-item">
				<div class="item mt40">
					管理后台核心功能
				</div>
				<div class="display-flex mt40">
					<div class="item1">
						<div>
							<img src="../../assets/icon_guanli01.png" class="item1Img"/>
						</div>
						<div class="item1Title">企业管理</div>
						<div class="item1Desc">
							多企业账号支持，适用于集团化企业或中介机构管理。数据分级与权限管理，确保信息安全与团队协作效率
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli02.png" class="item1Img"/>
						</div>
						<div class="item1Title">岗位管理</div>
						<div class="item1Desc">
							岗位信息发布与编辑，支持批量操作。智能化岗位推荐与自动投放功能，提高招聘效率
						</div>
					</div>
				</div>
				<div class="mt40 display-flex">
					<div class="item1">
						<div>
							<img src="../../assets/icon_guanli03.png" class="item1Img"/>
						</div>
						<div class="item1Title">简历管理</div>
						<div class="item1Desc">
							实时接收简历投递，支持筛选、分类、标签化管理。一键邀约面试与多渠道通知，节约沟通成本
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli04.png" class="item1Img"/>
						</div>
						<div class="item1Title">面试管理</div>
						<div class="item1Desc">
							在线安排面试，自动发送通知提醒。支持面试结果记录与后续流程跟进（如录用或不录用）
						</div>
					</div>
				</div>
				<div class="mt40 display-flex">
					<div class="item1">
						<div>
							<img src="../../assets/icon_guanli05.png" class="item1Img"/>
						</div>
						<div class="item1Title">用工档案管理</div>
						<div class="item1Desc">
							查看员工的当前用工记录（如所在岗位、薪资状态）。查询员工的历史用工记录（如曾服务的岗位、入离职时间等）
						</div>
					</div>
					<div class="item1 ml20" >
						<div>
							<img src="../../assets/icon_guanli06.png" class="item1Img"/>
						</div>
						<div class="item1Title">合同管理</div>
						<div class="item1Desc">
							多企业账号支持，适用于集团化企业或中介机构管理。数据分级与权限管理，确保信息安全与团队协作效率
						</div>
					</div>
				</div>
				<div class="mt40 display-flex">
					<div class="item1">
						<div>
							<img src="../../assets/icon_guanli07.png" class="item1Img"/>
						</div>
						<div class="item1Title">借款管理</div>
						<div class="item1Desc">
							员工可以申请借款，管理员可审核并发放。借款数据自动统计，还款状态实时更新，降低财务风险
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli08.png" class="item1Img"/>
						</div>
						<div class="item1Title">宿舍管理</div>
						<div class="item1Desc">
							宿舍分配与入住记录管理，支持申请与审核流程。自动生成宿舍使用报告，便于后续优化
						</div>
					</div>
				</div>
				<div class="mt40 display-flex justify-center">
					<div class="item1">
						<div>
							<img src="../../assets/icon_guanli09.png" class="item1Img"/>
						</div>
						<div class="item1Title">薪资计算与发放</div>
						<div class="item1Desc">
							自动化工资核算：支持按小时、按天、按月等多种计算方式。批量工资发放，支持银行对接或第三方支付
						</div>
					</div>
					<div class="item1 ml20" style="background: #ffffff;">
					</div>
				</div>
				<div class="item mt40">
					小程序端核心功能
				</div>
				<div class="itemType mt20">
					求职者端
				</div>
				<div class="mt40 display-flex">
					<div class="item1">
						<div>
							<img src="../../assets/icon_link01.png" class="item1Img"/>
						</div>
						<div class="item1Title">投递简历</div>
						<div class="item1Desc">
							快速匹配岗位，实时查看投递状态
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_link02.png" class="item1Img"/>
						</div>
						<div class="item1Title">分享岗位</div>
						<div class="item1Desc">
							成员可自由分享岗位，享受岗位邀约奖励
						</div>
					</div>
				</div>
				<div class="mt40 display-flex">
					<div class="item1">
						<div>
							<img src="../../assets/icon_link03.png" class="item1Img"/>
						</div>
						<div class="item1Title">面试通知</div>
						<div class="item1Desc">
							接收面试邀约，并提供地点/时间导航服务。
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_link04.png" class="item1Img"/>
						</div>
						<div class="item1Title">宿舍申请</div>
						<div class="item1Desc">
							根据企业安排快速申请宿舍，查看入住信息
						</div>
					</div>
				</div>
				<div class="mt40 display-flex">	
					<div class="item1">
						<div>
							<img src="../../assets/icon_link05.png" class="item1Img"/>
						</div>
						<div class="item1Title">借款申请</div>
						<div class="item1Desc">
							线上提交借款申请，实时查询审批状态。
						</div>
					</div>
					<div class="item1 ml20" style="background: #ffffff;">

					</div>
				</div>
				<div class="itemTyp mt40">
					管理员端
				</div>
				<div class="mt40 display-flex">
					<div class="item1">
						<div>
							<img src="../../assets/icon_guanli_01.png" class="item1Img"/>
						</div>
						<div class="item1Title">简历处理</div>
						<div class="item1Desc">
							通过手机即可筛选简历，安排面试，发送录用通知
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli_02.png" class="item1Img"/>
						</div>
						<div class="item1Title">岗位发布</div>
						<div class="item1Desc">
							随时新增或更新岗位信息，满足临时需求
						</div>
					</div>
				</div>
				<div class="mt40 display-flex">
					<div class="item1">
						<div>
							<img src="../../assets/icon_guanli_03.png" class="item1Img"/>
						</div>
						<div class="item1Title">借款审批</div>
						<div class="item1Desc">
							简化财务审批流程，提高审批效率
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli_04.png" class="item1Img"/>
						</div>
						<div class="item1Title">合同签署</div>
						<div class="item1Desc">
							支持电子签署合同功能，移动办公更高效
						</div>
					</div>
				</div>
				<div class="mt40 display-flex">
					<div class="item1">
						<div>
							<img src="../../assets/icon_guanli_05.png" class="item1Img"/>
						</div>
						<div class="item1Title">人员录入</div>
						<div class="item1Desc">
							支持线下拍照录入求职者信息，便于招聘会或现场招募。自动生成候选人档案，录入效率高，数据无缝接入后台管理系统。
						</div>
					</div>
					<div class="item1 ml20">
						<div>
							<img src="../../assets/icon_guanli_06.png" class="item1Img"/>
						</div>
						<div class="item1Title">员工档案</div>
						<div class="item1Desc">
							查看员工的当前用工记录（如所在岗位、薪资状态）。查询员工的历史用工记录（如曾服务的岗位、入离职时间等）
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="index-ai">
			<div class="indexOne">
				<div class="oneTitle">
					AI赋能人力资源  智慧驱动企业未来
				</div>
				<div class="oneDesc">
					通过AI技术，人力资源行业可以实现智能化招聘、员工管理和绩效评估，提升效率，降低成本，助力企业更快适应变化的市场需求。AI赋能，让人力资源管理更加精准、高效和创新
				</div>
				<div class="oneIcon">
					<img src="../../assets/pic_ai.png" class="aiImg"/>
				</div>
			</div>
			<div class="aiItem-flex">
				<div class="aiItem">
					<div class="aiItemAll">
						<div>
							<img src="../../assets/icon_ai01.png" class="aiItemIcon"/>
							<span class="aiItemTitle">简历筛选与匹配</span>
						</div>
						<div class="aiItemH1">
							自动化简历筛选
						</div>
						<div class="aiItemDesc">
							AI可以快速分析和处理大量简历，自动提取候选人关键信息，如技能、工作经验、学历等，并根据职位要求进行智能匹配，减少人工筛选的时间和错误
						</div>
						<div class="aiItemH1">
							精准岗位推荐
						</div>
						<div class="aiItemDesc">
							根据候选人的背景和技能，AI能够智能推荐最合适的职位，实现高效的人岗匹配
						</div>
					</div>
					<div class="aiItemAll mt20">
						<div>
							<img src="../../assets/icon_ai04.png" class="aiItemIcon"/>
							<span class="aiItemTitle">员工绩效管理</span>
						</div>
						<div class="aiItemH1">
							数据驱动的绩效评估
						</div>
						<div class="aiItemDesc">
							AI可以实时分析员工的工作数据、业绩和行为表现，提供准确的绩效评估，避免人为偏差和主观因素。
						</div>
						<div class="aiItemH1">
							智能反馈系统
						</div>
						<div class="aiItemDesc">
							AI能够为员工提供及时、个性化的反馈，帮助他们改进工作表现，并促进职业成长。
						</div>
					</div>
				</div>
				<div class="aiItem">
					<div class="aiItemAll">
						<div>
							<img src="../../assets/icon_ai02.png" class="aiItemIcon"/>
							<span class="aiItemTitle">智能面试与评估</span>
						</div>
						<div class="aiItemH1">
							视频面试分析
						</div>
						<div class="aiItemDesc">
							AI可以通过分析候选人在视频面试中的语言、面部表情和肢体语言，提供更全面的评估，帮助HR做出更加客观的决策。
						</div>
						<div class="aiItemH1">
							自动化面试安排
						</div>
						<div class="aiItemDesc">
							AI可以根据面试官和候选人的时间，自动安排面试并发送通知，优化面试流程
						</div>
					</div>
					<div class="aiItemAll mt20">
						<div>
							<img src="../../assets/icon_ai05.png" class="aiItemIcon"/>
							<span class="aiItemTitle">员工培训与发展</span>
						</div>
						<div class="aiItemH1">
							个性化学习推荐
						</div>
						<div class="aiItemDesc">
							AI根据员工的技能差距和发展需求，自动推荐适合的培训课程和学习路径，提升员工能力。
						</div>
						<div class="aiItemH1">
							发展路径预测
						</div>
						<div class="aiItemDesc">
							AI可以根据员工的历史表现、职业兴趣和行业趋势，预测其未来的职业发展方向，并提供相应的成长建议。
						</div>
					</div>
				</div>
				<div class="aiItem">
					<div class="aiItemAll">
						<div>
							<img src="../../assets/icon_ai03.png" class="aiItemIcon"/>
							<span class="aiItemTitle">智能外呼系统</span>
						</div>
						<div class="aiItemH1">
							自动化招聘外呼
						</div>
						<div class="aiItemDesc">
							AI智能外呼系统可自动拨打电话，根据预设脚本与候选人沟通，实时筛选合适人选并安排面试，大幅提升HR效率。
						</div>
						<div class="aiItemH1">
							离职员工回访
						</div>
						<div class="aiItemDesc">
							智能外呼系统可自动联系离职员工，调查离职原因并分析流失趋势，AI生成报告为HR提供参考，助力优化留任策略。
						</div>
					</div>
					<div class="aiItemAll mt20">
						<div>
							<img src="../../assets/icon_tj.png" class="aiItemIcon"/>
							<span class="aiItemTitle">人力资源数据分析与决策支持</span>
						</div>
						<div class="aiItemH1">
							人力资源数据分析
						</div>
						<div class="aiItemDesc">
							AI可以分析公司的人力资源数据，如招聘、离职、绩效等，为HR决策者提供数据支持，帮助制定更加精准的策略。
						</div>
						<div class="aiItemH1">
							趋势预测与规划
						</div>
						<div class="aiItemDesc">
							AI能够预测公司未来的人力需求，帮助HR做好人才储备与规划，优化用人结构
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="index-ai-small">
			<div class="indexOne">
				<div class="oneTitle">
					AI赋能人力资源  智慧驱动企业未来
				</div>
				<div class="oneDesc">
					通过AI技术，人力资源行业可以实现智能化招聘、员工管理和绩效评估，提升效率，降低成本，助力企业更快适应变化的市场需求。AI赋能，让人力资源管理更加精准、高效和创新
				</div>
				<div class="oneIcon">
					<img src="../../assets/pic_ai.png" class="aiImg"/>
				</div>
			</div>
			<div class="aiItem mt20">
				<div class="aiItemAll">
					<div>
						<img src="../../assets/icon_ai01.png" class="aiItemIcon"/>
						<span class="aiItemTitle">简历筛选与匹配</span>
					</div>
					<div class="aiItemH1">
						自动化简历筛选
					</div>
					<div class="aiItemDesc">
						AI可以快速分析和处理大量简历，自动提取候选人关键信息，如技能、工作经验、学历等，并根据职位要求进行智能匹配，减少人工筛选的时间和错误
					</div>
					<div class="aiItemH1">
						精准岗位推荐
					</div>
					<div class="aiItemDesc">
						根据候选人的背景和技能，AI能够智能推荐最合适的职位，实现高效的人岗匹配
					</div>
				</div>
				<div class="aiItemAll mt20">
					<div>
						<img src="../../assets/icon_ai04.png" class="aiItemIcon"/>
						<span class="aiItemTitle">员工绩效管理</span>
					</div>
					<div class="aiItemH1">
						数据驱动的绩效评估
					</div>
					<div class="aiItemDesc">
						AI可以实时分析员工的工作数据、业绩和行为表现，提供准确的绩效评估，避免人为偏差和主观因素。
					</div>
					<div class="aiItemH1">
						智能反馈系统
					</div>
					<div class="aiItemDesc">
						AI能够为员工提供及时、个性化的反馈，帮助他们改进工作表现，并促进职业成长。
					</div>
				</div>
			</div>
			<div class="aiItem mt20">
				<div class="aiItemAll">
					<div>
						<img src="../../assets/icon_ai02.png" class="aiItemIcon"/>
						<span class="aiItemTitle">智能面试与评估</span>
					</div>
					<div class="aiItemH1">
						视频面试分析
					</div>
					<div class="aiItemDesc">
						AI可以通过分析候选人在视频面试中的语言、面部表情和肢体语言，提供更全面的评估，帮助HR做出更加客观的决策。
					</div>
					<div class="aiItemH1">
						自动化面试安排
					</div>
					<div class="aiItemDesc">
						AI可以根据面试官和候选人的时间，自动安排面试并发送通知，优化面试流程
					</div>
				</div>
				<div class="aiItemAll mt20">
					<div>
						<img src="../../assets/icon_ai05.png" class="aiItemIcon"/>
						<span class="aiItemTitle">员工培训与发展</span>
					</div>
					<div class="aiItemH1">
						个性化学习推荐
					</div>
					<div class="aiItemDesc">
						AI根据员工的技能差距和发展需求，自动推荐适合的培训课程和学习路径，提升员工能力。
					</div>
					<div class="aiItemH1">
						发展路径预测
					</div>
					<div class="aiItemDesc">
						AI可以根据员工的历史表现、职业兴趣和行业趋势，预测其未来的职业发展方向，并提供相应的成长建议。
					</div>
				</div>
			</div>
			<div class="aiItem mt20">
				<div class="aiItemAll">
					<div>
						<img src="../../assets/icon_ai03.png" class="aiItemIcon"/>
						<span class="aiItemTitle">智能外呼系统</span>
					</div>
					<div class="aiItemH1">
						自动化招聘外呼
					</div>
					<div class="aiItemDesc">
						AI智能外呼系统可自动拨打电话，根据预设脚本与候选人沟通，实时筛选合适人选并安排面试，大幅提升HR效率。
					</div>
					<div class="aiItemH1">
						离职员工回访
					</div>
					<div class="aiItemDesc">
						智能外呼系统可自动联系离职员工，调查离职原因并分析流失趋势，AI生成报告为HR提供参考，助力优化留任策略。
					</div>
				</div>
				<div class="aiItemAll mt20">
					<div>
						<img src="../../assets/icon_tj.png" class="aiItemIcon"/>
						<span class="aiItemTitle">人力资源数据分析与决策支持</span>
					</div>
					<div class="aiItemH1">
						人力资源数据分析
					</div>
					<div class="aiItemDesc">
						AI可以分析公司的人力资源数据，如招聘、离职、绩效等，为HR决策者提供数据支持，帮助制定更加精准的策略。
					</div>
					<div class="aiItemH1">
						趋势预测与规划
					</div>
					<div class="aiItemDesc">
						AI能够预测公司未来的人力需求，帮助HR做好人才储备与规划，优化用人结构
					</div>
				</div>
			</div>
		</div>
		<div class="index-core">
			<div class="coreTitle">我们的核心价值</div>
			<div class="coreItem">
				<div class="coreItemOne">
					<div class="coreItemOneTitle">
						<div class="coreItemOneTitleText">企业端</div>
						<div class="coreItemOneTitleDesc">
							精准高效，优化人力管理
						</div>
					</div>
					<img src="../../assets/pic_fangkuai.png" class="coreItemOneImg"/>
					<div class="coreItemOneItem">
						<div class="displayFlex">
							<img src="../../assets/icon_qiye01.png" class="coreItemOneItemImg"/>
							<div>
								<div class="coreItemOneItemTitle">效率提升</div>
								<div class="coreItemOneItemDesc">通过智能化管理平台，优化招聘与用工管理流程</div>
							</div>
						</div>
					</div>
					<div class="coreItemOneItem">
						<div class="displayFlex">
							<img src="../../assets/icon_qiye02.png" class="coreItemOneItemImg"/>
							<div>
								<div class="coreItemOneItemTitle">成本降低</div>
								<div class="coreItemOneItemDesc">精简管理环节，提升人力资源配置效率</div>
							</div>
						</div>
					</div>
					<div class="coreItemOneItem">
						<div class="displayFlex">
							<img src="../../assets/icon_qiye03.png" class="coreItemOneItemImg"/>
							<div>
								<div class="coreItemOneItemTitle">风控保障</div>
								<div class="coreItemOneItemDesc">全程数字化管理，降低合规与财务风险</div>
							</div>
						</div>
					</div>
				</div>
				<div class="coreItemTwo">
					<div class="coreItemOneTitle">
						<div class="coreItemOneTitleText">求职者端</div>
						<div class="coreItemOneTitleDesc">
							随时随地，高效掌控人才管理
						</div>
					</div>
					<img src="../../assets/pic_ren.png" class="coreItemOneImg"/>
					<div class="coreItemOneItem">
						<div class="displayFlex">
							<img src="../../assets/icon_qiuzhi01.png" class="coreItemOneItemImg"/>
							<div>
								<div class="coreItemOneItemTitle">求职便捷</div>
								<div class="coreItemOneItemDesc">随时随地投递简历，快速匹配岗位</div>
							</div>
						</div>
					</div>
					<div class="coreItemOneItem">
						<div class="displayFlex">
							<img src="../../assets/icon_qiuzhi02.png" class="coreItemOneItemImg"/>
							<div>
								<div class="coreItemOneItemTitle">福利保障</div>
								<div class="coreItemOneItemDesc">宿舍申请、借款服务，让求职者安心工作</div>
							</div>
						</div>
					</div>
					<div class="coreItemOneItem">
						<div class="displayFlex">
							<img src="../../assets/icon_qiuzhi03.png" class="coreItemOneItemImg"/>
							<div>
								<div class="coreItemOneItemTitle">公开透明</div>
								<div class="coreItemOneItemDesc">平台保障双方权益，信息清晰可信</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="zhuanliFirst">
			<div class="zhuanliTitle">
				研发专利
			</div>
			<div class="zhuanliDesc">
				从一行代码到一个系统，我们的技术成果均通过国家软件著作权认证。这些不仅是法律保护，更是对用户安全与品质的承诺。
			</div>
			<div class="zhuanliItemWrap">
				<div class="zhuanliItem">
					<img src="../../assets/01.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/02.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/03.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/04.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/05.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/06.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/07.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/08.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/09.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/10.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/11.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/12.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/13.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/14.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/15.jpg" class="zhuanliItemImg"/>
				</div>
				<div class="zhuanliItem">
					<img src="../../assets/16.jpg" class="zhuanliItemImg"/>
				</div>
			</div>
		</div>
	</div>
	<div class="index-news">
		<div class="index-news-item" @click="toNews(0)">
			<img src="../../assets/pic_yangli.png" class="index-news-item-img"/>
			<div class="index-news-item-title">
				走起，京东送外卖？
			</div>
			<div class="desction index-news-item-desc">
				在这个快节奏的时代，选择一份适合自己的工作显得尤为重要。今天，我们以“走起，京东送外卖”为题，来探讨一下送外卖这份工作的实际情况，并与进厂打工进行对比分析，看看究竟哪一种工作更适合你。
			</div>
		</div>
		<div class="index-news-item-list">
			<div class="index-news-item-list-item" style="color: #006DF3;" @click="toNews(1)">
				<div class="index-news-item-list-item-date">
					<div class="index-news-item-list-item-date-num">26/05</div>
					<div class="index-news-item-list-item-date-year">2025</div>
				</div>
				<div class="index-news-item-list-item-content">
					<div class="index-news-item-list-item-content-title">网络身份证来了，进厂能用么？</div>
					<div class="desction index-news-item-list-content-desc" >大家听说了吗？咱们以后上网也有门槛了，得先办一个网络身份证了。今后没有网络身份证，你很有可能连这个网都上不了了。人人都可拥有的网络身份证真的要来了，微信、淘宝、小红书等APP 成为了首批试点。那么网络身份证到底是个啥？又有什么用呢？对键盘侠和网络犯罪有什么影响呢？本期节目咱们一起来揭秘。据环球网等多家媒体的报道，最近呢，不少网友发现，国家网络身份认证 APP 认证版。</div>
				</div>
			</div>
			<div class="index-news-item-list-item" @click="toNews(2)">
				<div class="index-news-item-list-item-date">
					<div class="index-news-item-list-item-date-num">04/06</div>
					<div class="index-news-item-list-item-date-year">2025</div>
				</div>
				<div class="index-news-item-list-item-content">
					<div class="index-news-item-list-item-content-title">未16岁是否可以进工厂工作?</div>
					<div class="desction index-news-item-list-content-desc">未16岁是否可以进工厂工作？未成年人不能进工厂工作，因为身体和心理发育不完全，不能承受高强度劳动和压力，也不能应对各种工作环境和风险，需要遵守相关法律法规和行业规定，保护他们的权益和健康。所以，一般至少要达到法定的16周岁才可以进厂工作。</div>
				</div>
			</div>
			<div class="index-news-item-list-item" @click="toNews(3)">
				<div class="index-news-item-list-item-date">
					<div class="index-news-item-list-item-date-num">14/06</div>
					<div class="index-news-item-list-item-date-year">2025</div>
				</div>
				<div class="index-news-item-list-item-content">
					<div class="index-news-item-list-item-content-title">建议大家不要轻易离职，找工作比上班还累</div>
					<div class="desction index-news-item-list-content-desc">2025年已经过半，不少人都在感慨：“今年的就业市场，真的太难了。”无论是应届毕业生、职场新人，还是有一定经验的中层员工，都感受到了来自市场的压力。岗位减少、裁员频繁、竞争激烈，这些词汇频频出现在社交平台和新闻报道中，“失业潮”似乎成为了不少人生活的关键词。</div>
				</div>
			</div>
			<div class="index-news-item-list-item" @click="toNews(4)">
				<div class="index-news-item-list-item-date">
					<div class="index-news-item-list-item-date-num">01/06</div>
					<div class="index-news-item-list-item-date-year">2025</div>
				</div>
				<div class="index-news-item-list-item-content">
					<div class="index-news-item-list-item-content-title">2025年失业人的路该咋样走？看看你有啥好的推荐？</div>
					<div class="desction index-news-item-list-content-desc">2025年对于失业者来说，找到合适的工作可能面临一定的挑战，但通过积极的态度和实际的行动，依然可以逐步实现再就业。以下是一些建议帮助失业者更好地规划自己的职业道路：</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>

export default {
		name: 'index',
		props: {
			msg: String
		},
	data() {
		return {
			showModal:false,
			type:1,
			itemType:1,
			item:1,
			newsList:['https://mp.weixin.qq.com/s?__biz=Mzk3NTQ3NDQ5Nw==&mid=2247483713&idx=2&sn=492d5c448f1018565b57fe32df85b305&chksm=c4ca5b6ff3bdd27990d7dc395737fa6b9245e15043bc048b14d4982e9efd7b1d7ead1f413642&scene=178&cur_album_id=4030000786301141000&search_click_id=#rd',
					  'https://mp.weixin.qq.com/s?__biz=Mzk3NTQ3NDQ5Nw==&mid=2247483765&idx=2&sn=7db2e7f73d0dc9a90b2061a7a6f2ac81&chksm=c4ca5b5bf3bdd24dc0b5bd126ec6eacc49266c9bc2aae5251e566b8773fdd15994f3eede0327&scene=178&cur_album_id=4030000786301141000&search_click_id=#rd',
					  'https://mp.weixin.qq.com/s?__biz=Mzk3NTQ3NDQ5Nw==&mid=2247483769&idx=2&sn=9382bbe0bd97daabdb5e1534b132ed99&chksm=c4ca5b57f3bdd24147a9348b22a62853ad552f9dc20e82fb8496e83d26df47c8253477934457&scene=178&cur_album_id=4030000786301141000&search_click_id=#rd',
					  'https://mp.weixin.qq.com/s?__biz=Mzk3NTQ3NDQ5Nw==&mid=2247483775&idx=1&sn=08b1d1093882b56ae34c82ad7f67cc0d&chksm=c4ca5b51f3bdd24714b804930615af9d22e56d9094bfcbcacfb0f80736a68c37d443257a72ca&scene=178&cur_album_id=4030000786301141000&search_click_id=#rd',
					  'https://mp.weixin.qq.com/s?__biz=Mzk3NTQ3NDQ5Nw==&mid=2247483779&idx=1&sn=4a8f93f0ac5eece9ea281be834c6e3d5&chksm=c4ca5badf3bdd2bb925343d2e136a02a0a55f79082c7f1c82004a9fbcbe4a9a43b1d374e079f&scene=178&cur_album_id=4030000786301141000&search_click_id=#rd']
		};
	},
	created() {
	  
	},
	methods: {
		changeItem(val){
			this.item = val;
		},
		changeType(val){
			this.type = val;
		},
		changeItemType(val){
			this.itemType = val;
		},
		showPop(){
			this.$emit('pop',true);
		},
		changeModel(val){
			this.showModal = val;
		},
		toNews(val){
			const link = this.newsList[val];
			window.open(link);
		}
	}
}
</script>

<style scoped>
@import './index.css';
</style>
